import React from "react";
import ExlyTable from "common/Components/ExlyTable";
import { getManageRecordingsTableColumnConfig } from "../../columnConfig/ManageRecordings.columnConfig";
import { SectionHeading } from "features/AdminPanel/modules/SectionHeading/SectionHeading";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { useManageRecordingsListTable } from "./hooks/useManageRecordingsListTable";
import {
  RECORDING_DETAILS_MODAL_CONSTANTS,
  MANAGE_RECORDINGS_LIST_TABLE_TEXTS,
} from "./constants/ManageRecordingsListTable.constant";

import { RecordingSettingsModal } from "../RecordingSettingsModal/RecordingSettingsModal";

export const ManageRecordingsListTable = (props) => {
  const { tableProps, recordingProps } = props;
  const {
    isDesktop,
    isRecordedCourse,
    shareModalData,
    handleOpenShareModal,
    handleCloseShareModal,
    handleCopyShareUrl,
    handleCopyPassword,
  } = useManageRecordingsListTable(recordingProps);

  return (
    <div>
      <div>
        {isDesktop && (
          <SectionHeading
            heading={MANAGE_RECORDINGS_LIST_TABLE_TEXTS.HEADING}
            headerRight={
              <RecordingSettingsModal
                isDesktop={isDesktop}
                listingUuid={
                  recordingProps?.parentOffering?.uuid ||
                  recordingProps?.listingUuid
                }
              />
            }
          />
        )}
        <ExlyTable
          ra_props={{
            ...tableProps,
            filter: {
              ...tableProps?.filter,
              use_all_recordings_api: true,
              is_recorded_course: isRecordedCourse,
            },
          }}
          noExportButton
          layoutProps={{
            exlyTableRootClass:
              MANAGE_RECORDINGS_LIST_TABLE_TEXTS.LAYOUT_ROOT_CLASS,
          }}
          columnConfig={getManageRecordingsTableColumnConfig(
            handleOpenShareModal,
            handleCopyPassword
          )}
          borderedFields
          fieldsLeftPadded
          drawerFieldsBordered
          fieldsAlignment={
            MANAGE_RECORDINGS_LIST_TABLE_TEXTS.ALIGNMENT_SPACE_BETWEEN
          }
          drawerFieldsAlignment={
            MANAGE_RECORDINGS_LIST_TABLE_TEXTS.ALIGNMENT_SPACE_BETWEEN
          }
          primaryKey={MANAGE_RECORDINGS_LIST_TABLE_TEXTS.PRIMARY_KEY_ID}
          empty_list_icon={
            MANAGE_RECORDINGS_LIST_TABLE_TEXTS.EMPTY_LIST_ICON_PATH
          }
          alt={MANAGE_RECORDINGS_LIST_TABLE_TEXTS.EMPTY_LIST_ALT}
          content_title={MANAGE_RECORDINGS_LIST_TABLE_TEXTS.EMPTY_LIST_TITLE}
        >
          {MANAGE_RECORDINGS_LIST_TABLE_TEXTS.EMPTY_LIST_DESC}
        </ExlyTable>

        {!!shareModalData && (
          <ExlyModal
            open={!!shareModalData}
            onClose={handleCloseShareModal}
            title={RECORDING_DETAILS_MODAL_CONSTANTS.title}
            primaryBtnText={RECORDING_DETAILS_MODAL_CONSTANTS.primaryBtnText}
            onPrimaryBtnClick={handleCloseShareModal}
          >
            <div className="tw-p-4 tw-flex tw-flex-col tw-gap-4">
              <div>
                <label className="tw-block tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase tw-tracking-wider tw-mb-1">
                  {RECORDING_DETAILS_MODAL_CONSTANTS.shareUrlLabel}
                </label>
                <div className="tw-flex tw-items-center tw-gap-2 tw-bg-gray-50 tw-p-2.5 tw-rounded-lg tw-border tw-border-gray-200">
                  <span
                    className="tw-text-sm tw-text-gray-800 tw-truncate tw-flex-1 tw-whitespace-nowrap"
                    title={shareModalData?.share_url || ""}
                  >
                    {shareModalData?.share_url ||
                      MANAGE_RECORDINGS_LIST_TABLE_TEXTS.EMPTY_RECORD_FALLBACK}
                  </span>
                  {shareModalData?.share_url && (
                    <button
                      type="button"
                      onClick={handleCopyShareUrl}
                      title={
                        RECORDING_DETAILS_MODAL_CONSTANTS.copyShareUrlTooltip
                      }
                      className="tw-p-1.5 tw-text-gray-600 hover:tw-text-blue-600 tw-border-none tw-rounded hover:tw-bg-gray-200 tw-shrink-0 tw-transition-colors"
                    >
                      <FileCopyIcon style={{ fontSize: 18 }} />
                    </button>
                  )}
                </div>
              </div>

              <div>
                <label className="tw-block tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase tw-tracking-wider tw-mb-1">
                  {RECORDING_DETAILS_MODAL_CONSTANTS.passwordLabel}
                </label>
                <div className="tw-flex tw-items-center tw-gap-2 tw-bg-gray-50 tw-p-2.5 tw-rounded-lg tw-border tw-border-gray-200">
                  <span className="tw-text-sm tw-font-mono tw-text-gray-800 tw-flex-1 tw-truncate tw-whitespace-nowrap">
                    {shareModalData?.password ||
                      MANAGE_RECORDINGS_LIST_TABLE_TEXTS.EMPTY_RECORD_FALLBACK}
                  </span>
                  {shareModalData?.password && (
                    <button
                      type="button"
                      onClick={handleCopyPassword}
                      title={
                        RECORDING_DETAILS_MODAL_CONSTANTS.copyPasswordTooltip
                      }
                      className="tw-p-1.5 tw-border-none tw-text-gray-600 hover:tw-text-blue-600 tw-rounded hover:tw-bg-gray-200 tw-shrink-0 tw-transition-colors"
                    >
                      <FileCopyIcon style={{ fontSize: 18 }} />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </ExlyModal>
        )}
      </div>
    </div>
  );
};
